'use client';
import Link from 'next/link';
import { forwardRef, type ComponentProps } from 'react';
import { useI18n } from './LocaleProvider';
const LocalizedLink = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(function LocalizedLink(props, ref) {
  const { href } = useI18n();
  return <Link {...props} ref={ref} href={typeof props.href === 'string' ? href(props.href) : props.href} />;
});
export default LocalizedLink;
